import type { LucideIcon } from 'lucide-react'
import { Download } from 'lucide-react'

import { IconButton } from 'slab'

export interface ReportRowProps {
  icon: LucideIcon
  label: string
  onDownload: () => void
  isLoading?: boolean
  disabled?: boolean
}

export default function ReportRow ({ icon: Icon, label, onDownload, isLoading, disabled }: ReportRowProps) {
  return (
    <div className='flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-100 p-2'>
      <div className='flex h-[18px] items-center'>
        <Icon size={16} className='text-gray-600' />
      </div>
      <p className='flex-1 body-sm text-gray-800'>
        {label}
      </p>
      <IconButton
        icon={Download}
        label={`Download ${label}`}
        size='small'
        onClick={onDownload}
        disabled={disabled || isLoading}
      />
    </div>
  )
}
